import React from 'react';

const E  = '#7C4DFF';
const N  = '#0A2540';

const competencies = [
  { icon: 'fas fa-handshake',          label: 'Donor Relationships' },
  { icon: 'fas fa-users',              label: 'Team Management' },
  { icon: 'fas fa-chart-line',         label: 'Monitoring & Evaluation' },
  { icon: 'fas fa-chalkboard-teacher', label: 'Capacity Building' },
  { icon: 'fas fa-comments',           label: 'Stakeholder Engagement' },
  { icon: 'fas fa-project-diagram',    label: 'Project Development' },
  { icon: 'fas fa-tasks',              label: 'Project Management' },
  { icon: 'fas fa-mobile-alt',         label: 'Product Development' },
  { icon: 'fas fa-shield-alt',         label: 'Risk & Compliance' },
];

const tools = [
  'Scrum / Agile', 'Microsoft Project', 'Power BI', 'Financial Modelling',
  'Data Analysis', 'Business Intelligence', 'Budget Management', 'Research Design',
  'Report Writing', 'Mobile Money Systems', 'Financial Literacy',
];

export default function Skills() {
  return (
    <section id="skills" className="section section-alt">
      <div className="container">
        <div className="section-header">
          <h2>Core Competencies</h2>
          <div className="section-divider" />
          <p style={{ marginTop: 12 }}>A blend of management, technical, and research skills honed across diverse sectors.</p>
        </div>

        {/* Competency cards */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 20, marginBottom: 56 }}>
          {competencies.map(c => (
            <div key={c.label} style={{
              background: '#fff', borderRadius: 12,
              border: '1px solid #E2E8F0', padding: '22px 20px',
              display: 'flex', alignItems: 'center', gap: 16,
              boxShadow: '0 2px 12px rgba(10,37,64,0.05)',
              transition: 'all 0.3s', cursor: 'default',
            }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = E; e.currentTarget.style.transform = 'translateY(-3px)'; e.currentTarget.style.boxShadow = '0 8px 24px rgba(124,77,255,0.14)'; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = '#E2E8F0'; e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = '0 2px 12px rgba(10,37,64,0.05)'; }}
            >
              {/* Icon — neutral navy bg, emerald icon */}
              <div style={{
                width: 46, height: 46, borderRadius: 10, flexShrink: 0,
                background: 'rgba(10,37,64,0.06)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}>
                <i className={c.icon} style={{ color: N, fontSize: '1.1rem' }} />
              </div>
              <span style={{ fontWeight: 600, color: N, fontSize: '0.92rem' }}>{c.label}</span>
            </div>
          ))}
        </div>

        {/* Tools — clean white pills */}
        <div style={{ textAlign: 'center' }}>
          <h3 style={{ color: N, marginBottom: 20, fontSize: '1.1rem', fontWeight: 700 }}>
            Tools, Technologies & Certifications
          </h3>
          <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 10 }}>
            {tools.map(t => (
              <span key={t} style={{
                background: '#fff', color: N,
                border: '1px solid #E2E8F0',
                padding: '7px 18px', borderRadius: 20,
                fontSize: '0.85rem', fontWeight: 600,
                boxShadow: '0 1px 4px rgba(10,37,64,0.06)',
                transition: 'all 0.2s',
              }}
                onMouseEnter={e => { e.currentTarget.style.borderColor = E; e.currentTarget.style.color = E; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor = '#E2E8F0'; e.currentTarget.style.color = N; }}
              >
                {t}
              </span>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) { #skills .container > div:first-of-type { grid-template-columns: repeat(2, 1fr) !important; } }
        @media (max-width: 480px) { #skills .container > div:first-of-type { grid-template-columns: 1fr !important; } }
      `}</style>
    </section>
  );
}
